import { useCallback } from 'react';

import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuidesArticle/pageContext';
import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import type { Channel } from './types';

export function useGetShareContent(): ShareActionsOptions<Channel>['getContent'] {
	const {
		data: {
			article: { heading },
		},
	} = usePetitionGuidesPageData();

	return useCallback(
		(channel, type, { url }) => {
			switch (channel) {
				case 'twitter':
					return url;
				case 'email':
					if (type === 'title') return heading;
					return url;
				default:
					return '';
			}
		},
		[heading],
	);
}
